// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2F3Uf","rootCenter":"LoadMoreObserver_rootCenter__2vJYs","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__fbM92"};